export function StepPage({ children }) {
  return (
    <div className="p-20 pt-12 bg-[url('/public/images/demo/rate-disco-bg.png')] bg-cover bg-right-top min-h-screen">
			<div className="flex flex-col max-w-[850px] text-white font-['Montserrat'] ml-auto mr-auto">
      	{children}
			</div>
    </div>
  );
}
